"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossellLinkIconType = exports.LinkVariantType = exports.LinkActionType = void 0;
var LinkActionType;
(function (LinkActionType) {
    LinkActionType["NAVIGATION"] = "NAVIGATION";
    LinkActionType["INLINE"] = "INLINE";
})(LinkActionType || (exports.LinkActionType = LinkActionType = {}));
var LinkVariantType;
(function (LinkVariantType) {
    LinkVariantType["PRIMARY"] = "PRIMARY";
    LinkVariantType["SECONDARY"] = "SECONDARY";
    LinkVariantType["SECONDARY_ALTERNATIVE"] = "SECONDARY_ALTERNATIVE";
})(LinkVariantType || (exports.LinkVariantType = LinkVariantType = {}));
var CrossellLinkIconType;
(function (CrossellLinkIconType) {
    CrossellLinkIconType["CHEVRON_RIGHT_FIT"] = "CHEVRON_RIGHT_FIT";
    CrossellLinkIconType["CHEVRON_RIGHT_PX_FIT"] = "CHEVRON_RIGHT_PX_FIT";
    CrossellLinkIconType["CHEVRON_RIGHT_PX"] = "CHEVRON_RIGHT_PX";
    CrossellLinkIconType["CHEVRON_RIGHT_SMALL_FIT"] = "CHEVRON_RIGHT_SMALL_FIT";
    CrossellLinkIconType["CHEVRON_RIGHT_SMALL_PX_FIT"] = "CHEVRON_RIGHT_SMALL_PX_FIT";
    CrossellLinkIconType["CHEVRON_RIGHT_SMALL_PX"] = "CHEVRON_RIGHT_SMALL_PX";
    CrossellLinkIconType["CHEVRON_RIGHT_SMALL"] = "CHEVRON_RIGHT_SMALL";
    CrossellLinkIconType["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
})(CrossellLinkIconType || (exports.CrossellLinkIconType = CrossellLinkIconType = {}));
//# sourceMappingURL=crossellModule.js.map